/** @jsx jsx */
import { jsx } from '@emotion/core'
import { DatePicker, Select, Button, message } from 'antd'
import { getApiTargetInfo } from 'core'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import React, { useState, useContext, useEffect } from 'react'
import R from 'ramda'
import { connect } from 'react-redux'
import {
  DataContext,
  DatePickerContext,
  ErrorContext,
  SpinContext,
} from 'context'
import {
  wind2Level2Validation,
  wind2PlantSelection,
  wind2AllSubgroup,
} from 'api/pgads'
import { getValidPlantList } from './wind2utils'
import {
  JcTmpErrorTable,
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'

const Wind2Level2Validation = ({ targetInfo }) => {
  const { setSelectedDate, selectedDate } = useContext(DatePickerContext)
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [plantList, setPlantList] = useState([])
  const [subGroupList, setSubGroupList] = useState([])
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const {
    selectedWind2Plant,
    setSelectedWind2Plant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedWind2Plant)
    ? selectedWind2Plant[0]
    : selectedWind2Plant
  const [data, setData] = useState([])
  const clearData = _ => {
    setData([])
  }

  useEffect(
    _ => {
      wind2AllSubgroup(targetInfo).fork(setError, setSubGroupList)
    },
    [setError, targetInfo]
  )
  useEffect(
    _ => {
      // make sort plantName
      wind2PlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
        // const sd = R.sortBy(R.prop('plantName'), data)
        // setPlantSelectionData(sd)
        // if (!plantSelected && sd[0] && sd[0].plantId)
        //   setPlantSelected(sd[0].plantId)
      })
    },
    [targetInfo, selectedDate, setError, plantSelected]
  )

  useEffect(() => {
    const stoList = getValidPlantList(plantList, subGroupList, [])
    setPlantSelectionData(stoList)
    const isValidSelection = stoList.some(p => p.plantId === plantSelected)
    if (!isValidSelection && stoList[0] && stoList[0].plantId) {
      if (plantSelected !== stoList[0].plantId) {
        setPlantSelected([stoList[0].plantId])
      }
    }
  }, [plantList, plantSelected, setPlantSelected, subGroupList])

  const onLevel2Validation = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    setSpinning(true)
    wind2Level2Validation(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, data => {
      setSpinning(false)
      setData(data)
      if (data.length <= 0 || !isErrorContains(data)) {
        message.info('Level 2 Validation completed successfully.')
      }
    })
  }
  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '300px 200px 200px auto auto',
            gap: '5px',
          }}
        >
          <Title> Wind Level 2 Validation</Title>
          <Select
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              setPlantSelected([plantId])
              clearData()
            }}
          >
            {R.sortBy(R.prop('plantName'), plantSelectionData).map(
              ({ plantName, plantId }) => (
                <Select.Option key={plantId} value={plantId}>
                  {plantName}
                </Select.Option>
              )
            )}
          </Select>
          <DatePicker.MonthPicker
            allowClear={false}
            style={{ width: '100%' }}
            format="MMMM-YYYY"
            value={selectedDate}
            onChange={d => {
              setSelectedDate(d.endOf('month'))
              clearData()
            }}
          />
          <Button
            type="primary"
            onClick={onLevel2Validation}
            icon="database"
            // style={{ width: '100%' }}
          >
            Level 2 Validation
          </Button>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={200} widthOffset={20}>
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <JcTmpErrorTable errors={data} scroll={{ y: height - 80 }} />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2Level2Validation)
